import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthStateService } from './auth-state.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private authState = inject(AuthStateService);
  private router = inject(Router);
  private refreshPromise: Promise<string | null> | null = null;

  async refreshToken(): Promise<string | null> {
    if (!this.refreshPromise) {
      this.refreshPromise = this.doRefreshToken().finally(() => {
        this.refreshPromise = null;
      });
    }
    return this.refreshPromise;
  }

  private async doRefreshToken(): Promise<string | null> {
    try {
      const res = await firstValueFrom(
        this.http.post<any>(`${environment.apiBaseUrl}/user/auth/refresh`, {}, {
          headers: { '__skipAuthInterceptor': 'true' },
          withCredentials: true,
        })
      );
      const result = res?.result ?? null;
      const newToken = result?.token ?? null;
      if (newToken && result) {
        this.authState.currentUser = {
          ...(this.authState.currentUser ?? {}),
          ...result,
          token: newToken,
        };
      }
      return newToken;
    } catch {
      return null;
    }
  }

  async logout(): Promise<void> {
    try {
      await firstValueFrom(
        this.http.post(`${environment.apiBaseUrl}/user/logout`, {})
      );
    } catch {}
    this.authState.logout();
    this.authState.clearSession();
    await this.router.navigate(['/login']);
  }
}
